import { ZohoPostLeadRequest } from "@givenergy/sales-simple-energy-comparison";
import { ServiceBase } from "@services/service-base.ts";

export class ZohoService extends ServiceBase {
  async createLead(userId: string, data: ZohoPostLeadRequest) {
    const createLeadUrl = new URL("create-lead", this.apiUrl);

    const request = await fetch(createLeadUrl, {
      method: "POST",
      headers: {
        "givenergy-userid": userId,
      },
      body: JSON.stringify(data),
    });

    if (!request.ok) {
      throw new Error("Failed to create new lead");
    }
  }
}
